import type { EntitlementRule } from '@/api/auth/missionImpactAuthAPI.schemas';

/**
 * Formats a polymorphic entitlement rule into a short human-readable summary. A composite is
 * formatted as the joined summary of its constituent rules.
 */
export function formatEntitlementRule(rule: EntitlementRule | null | undefined): string {
  if (!rule) return '—';

  switch (rule.type) {
    case 'cumulative':
      return `Cumulative: ${rule.count}`;
    case 'minimum':
      return `Minimum: ${rule.minimum}`;
    case 'capability':
      return rule.capabilities.length > 0
        ? `Capabilities: ${rule.capabilities.join(', ')}`
        : 'Capabilities: (none)';
    case 'composite': {
      const parts = rule.rules
        .map((leaf) => formatEntitlementRule(leaf))
        .filter((part) => part !== '—');
      return parts.length > 0 ? parts.join(' · ') : '—';
    }
    default:
      return '—';
  }
}
